import { ROUNDED_BUTTON_BORDER_RADIUS, ROUNDED_BUTTON_PADDING, STANDARD_BUTTON_BORDER_RADIUS, } from './constants';
export function getBorderRadiusProps(roundLeftEdgeYn, roundRightEdgeYn) {
    return {
        borderTopLeftRadius: roundLeftEdgeYn
            ? ROUNDED_BUTTON_BORDER_RADIUS
            : STANDARD_BUTTON_BORDER_RADIUS,
        borderBottomLeftRadius: roundLeftEdgeYn
            ? ROUNDED_BUTTON_BORDER_RADIUS
            : STANDARD_BUTTON_BORDER_RADIUS,
        borderTopRightRadius: roundRightEdgeYn
            ? ROUNDED_BUTTON_BORDER_RADIUS
            : STANDARD_BUTTON_BORDER_RADIUS,
        borderBottomRightRadius: roundRightEdgeYn
            ? ROUNDED_BUTTON_BORDER_RADIUS
            : STANDARD_BUTTON_BORDER_RADIUS,
    };
}
export function getPadding(roundLeftEdgeYn, roundRightEdgeYn) {
    return {
        paddingTop: '0',
        paddingBottom: '0',
        paddingLeft: roundLeftEdgeYn ? ROUNDED_BUTTON_PADDING : '1.0rem',
        paddingRight: roundRightEdgeYn ? ROUNDED_BUTTON_PADDING : '1.0rem',
    };
}
//# sourceMappingURL=buttons.js.map